/*
  CC接口请求出错误码提示
*/
export let resCode = {
    400:'非法请求',
    // '用户不存在',
    401:'用户或密码错误',
    // '用户密码错误',
    402:'用户或密码错误',
    403:'登录无效',
    404:'无法使用',
    405:'账号被锁',
    406:'系统维护中',
    407:'密码过期',
    408:'未知错误',
    500:'服务器异常'
}